import React, { useMemo } from "react";
import { Barricade } from "@phosphor-icons/react";
import { closuresNearEvac } from "../../lib/evacRoads";
import { EVAC_LEVEL_META } from "./SheriffEvacLayer";

export default function EvacClosuresStrip({ evac, closures = [], wsdotAlerts = [], onRoadClick }) {
  const roads = useMemo(
    () => closuresNearEvac(evac, closures, wsdotAlerts),
    [evac, closures, wsdotAlerts],
  );
  if (!evac) return null;
  const meta = EVAC_LEVEL_META[evac.level] || EVAC_LEVEL_META[1];
  const shown = roads.slice(0, 3);
  return (
    <div
      data-testid="evac-closures-strip"
      className="absolute bottom-0 left-0 right-0 z-[1000] px-4 py-2 bg-tac-bg/90 backdrop-blur-md border-t"
      style={{ borderColor: `${meta.color}66` }}
    >
      <div className="flex items-start gap-2 text-[13px] leading-snug">
        <Barricade size={14} weight="fill" className="text-tac-warning shrink-0 mt-0.5" />
        {roads.length === 0 ? (
          <span className="text-tac-dim">
            No road closures reported near <span className="font-bold text-tac-text">{evac.title}</span>.
          </span>
        ) : (
          <span className="text-tac-dim min-w-0">
            <span className="font-bold uppercase tracking-wider text-tac-warning text-[11px]">
              Road closures in this evac area:
            </span>{" "}
            {shown.map((c, i) => (
              <span key={c.id} className="text-tac-text">
                {i > 0 && <span className="text-tac-faint"> · </span>}
                <button
                  type="button"
                  data-testid={`strip-road-${c.id}`}
                  onClick={() => c.lat != null && onRoadClick?.(c.lat, c.lon)}
                  className="font-semibold underline decoration-dotted underline-offset-2 hover:text-tac-primary transition-colors"
                  title="Pan map to this closure"
                >
                  {c.name}
                  {c.milepost != null ? ` MP ${c.milepost}` : ""}
                </button>
                <span className="font-mono-tac text-tac-faint"> ({c._d.toFixed(1)} mi)</span>
              </span>
            ))}
            {roads.length > shown.length && (
              <span className="text-tac-faint"> · +{roads.length - shown.length} more</span>
            )}
          </span>
        )}
      </div>
    </div>
  );
}
